import { LMEUserSettings } from "@mcleod/general";
import { Component, DataSource, DataSourceRemoteDataChangeEvent, PanelProps, Tab } from "@mcleod/components";
import { UserLayoutProvider } from "@mcleod/common";
import { AutogenLayoutOrderPayablesMultiProfile } from "./autogen/AutogenLayoutOrderPayablesMultiProfile";
import { MultiProfilePlanningTabs } from "@mcleod/dispatch/src/planning/MultiProfilePlanningTabs";
import { OrderPayables } from "./OrderPayables";

export class OrderPayablesMultiProfile extends AutogenLayoutOrderPayablesMultiProfile{
    private userProfiles: string[] = [];

    async onLoad(): Promise<void> {
        if (LMEUserSettings.get()?.order_payables_profile != null)
            this.userProfiles.push(LMEUserSettings.get().order_payables_profile);
        if (LMEUserSettings.get()?.order_payables_profile2 != null)
            this.userProfiles.push(LMEUserSettings.get().order_payables_profile2);
        if (LMEUserSettings.get()?.order_payables_profile3 != null)
            this.userProfiles.push(LMEUserSettings.get().order_payables_profile3);
        if (LMEUserSettings.get()?.order_payables_profile4 != null)
            this.userProfiles.push(LMEUserSettings.get().order_payables_profile4);

        new MultiProfilePlanningTabs({
            tabset: this.tabsetOrderPayablesProfiles,
            profileDataSource: this.sourceOrderPayablesProfile,
            mainLayoutName: "lme/settlement/OrderPayables",
            advancedFilterLayout: "lme/settlement/OrderPayablesProfileFilter",
            startingProfiles: this.userProfiles,
            profileDescrFieldName: "descr",
            userSettingsCallback: () => UserLayoutProvider.navigateTo(null, null, { scrollTo: "tabBackOffice" })
        });
        this.sourceOrderPayablesCache.search({ is_dummy: true }).then(() => this.sourceOrderPayablesCache.clear());
        this.sourceVoidedPayablesOrderPayables.search().then(() => this.sourceVoidedPayablesOrderPayables.clear());
    }

    handleRemoteDataChange(event: DataSourceRemoteDataChangeEvent) {
        event.preventDefault();
        this.tabsetOrderPayablesProfiles.tabs.forEach((tab: Tab) => {
            tab.components.forEach((component: Component) => {
                if (component instanceof OrderPayables) {
                    if ("lme/settlement/order-payables-cache" === (event.target as DataSource).url) {
                        const dataSource = component.sourceOrderPayablesCache;
                        dataSource.handleDataChange(event.change);
                    } else if ("lme/settlement/voided-payables-order-payables" === (event.target as DataSource).url) {
                        const dataSource = component.sourceVoidedPayablesOrderPayables;
                        dataSource.handleDataChange(event.change);
                    }
                }
            });
        });
    }

    // Override the main router's padding to get the vertical profile tabset to be flush with the edge of the screen
    getRouterProps(): Partial<PanelProps> {
        return { padding: 0 };
    }
}
